import React from 'react'
import LazyLoad from '../LazyLoad'

export const Positions = ({
  positions = [],
  selectedFilters,
  setSelectedFilters,
}) => {
  const onPress = (item) => {
    setSelectedFilters({ ...selectedFilters, position: item })
  }

  let buttonWidth = '23.5%'
  let columnGap = '2%'
  if (positions.length === 2) {
    buttonWidth = '49%'
  } else if (positions.length === 3) {
    buttonWidth = '32%'
  }

  return (
    <div
      style={{
        fontSize: '16px',
        fontFamily: ' Roboto, sans-serif',
        width: '100%',
      }}
      className="ClearTheCharts__label"
    >
      <p>Hero position</p>
      <div style={{ columnGap }} className="PreflopCharts__options-row">
        {!positions?.length ? (
          <LazyLoad />
        ) : (
          positions.map((position, idx) => {
            let positionLabel = position
            if (position === 'UTG+2') positionLabel = 'LJ'
            if (position === 'UTG+3') positionLabel = 'HJ'

            const isSelected = positionLabel === selectedFilters.position

            return (
              <div
                key={position}
                onClick={() => onPress(position)}
                className="PreflopCharts__button"
                style={{
                  maxWidth: buttonWidth,
                  minWidth: buttonWidth,
                  borderWidth: isSelected ? '2px' : 0,
                }}
              >
                <div
                  className="PreflopCharts__button-label"
                  style={{
                    color: isSelected ? '#0085FF' : 'black',
                  }}
                >
                  {position}
                </div>
              </div>
            )
          })
        )}
      </div>
    </div>
  )
}
